<template>
  <div class="prodOptionsFont bg-light flex-fill bd-highlight px-2">
    <div v-if="step >= 2" class="prodOption ms-3 mt-4">
      <h2 class="" id="pro-opt" :class="classes.prodOptionHead">
        Product opties
      </h2>
      <!-- start step 2 -->
      <div v-if="step === 2">
        <!-- packaging -->
        <div
          :class="classes.container"
          v-if="fields.packaging.use || fields.width.use || fields.length.use"
        >
          <div
            class="d-flex flex-row"
            v-if="fields.width.use"
            :class="classes.container"
          >
            <p :class="classes.text">Breedte:</p>
            <p :class="classes.text">
              {{ fields.width.value }}{{ fields.width.unit }}
            </p>
          </div>
          <div
            class="d-flex flex-row"
            v-if="fields.length.use"
            :class="classes.container"
          >
            <p :class="classes.text">Lengte:</p>
            <p :class="classes.text">
              {{ fields.length.value }}{{ fields.length.unit }}
            </p>
          </div>
          <div
            class="d-flex flex-row"
            v-if="fields.packaging.value !== 0"
            :class="classes.container"
          >
            <p :class="classes.text">Aantal planken in een pak:</p>
            <p :class="classes.text">{{ fields.packaging.value }}</p>
          </div>
          <div
            class="d-flex flex-row"
            v-if="fields.packaging.use"
            :class="classes.container"
          >
            <p :class="classes.text + ' nr-package'">Aantal pakken:</p>
            <input
              type="number"
              v-model="binds.number"
              min="0"
              :class="classes.input"
            />
          </div>
        </div>
        <!-- carton -->
        <div :class="classes.container" v-if="fields.carton.use">
          <div class="d-flex flex-row">
            <p :class="classes.text + ' nr'">Aantal:</p>
            <input
              type="number"
              v-model="binds.number"
              min="0"
              :class="classes.input"
            />
          </div>
        </div>
        <!-- rol -->
        <div
          :class="classes.container"
          v-if="fields.rol.use && fields.carton.use === false"
        >
          <div
            class="d-flex flex-row"
            v-if="fields.rol.value !== 0"
            :class="classes.container"
          >
            <p :class="classes.text">Meter op rol:</p>
            <p :class="classes.text">
              {{ fields.rol.value }}{{ fields.rol.unit }}
            </p>
          </div>
          <div
            class="d-flex flex-row"
            v-if="fields.rol.options.length === 1"
            :class="classes.container"
          >
            <p :class="classes.text">Rolbreedte:</p>
            <p :class="classes.text">
              {{ fields.rol.options[0] }}{{ fields.rol.unit }}
            </p>
          </div>
          <div class="d-flex flex-row" v-if="fields.rol.options.length > 1">
            <p :class="classes.text" id="roll-wi">Rolbreedte:</p>
            <select :class="classes.select" v-model="binds.width">
              <option id="opt" value="" selected>Keuze</option>
              <template
                v-for="option in fields.rol.options"
                :key="option.index"
              >
                <option :value="option">
                  {{ option }} {{ fields.rol.unit }}
                </option>
              </template>
            </select>
          </div>
          <div :class="classes.container">
            <div class="d-flex flex-row">
              <p :class="classes.text + ' nr-roll'">Aantal rollen:</p>
              <input
                type="number"
                v-model="binds.number"
                min="0"
                :class="classes.input"
              />
            </div>
          </div>
        </div>
        <!-- end step 2 -->
      </div>
      <!-- start step 3 -->
      <div v-if="step === 3" class="ms-3">
        <!-- color image -->
        <div :class="classes.container">
          <div class="row">
            <p :class="classes.text + ' color'">Kleur:</p>
            <p :class="classes.prodColor">{{ productLabel }}</p>
          </div>
        </div>
        <!-- rol -->
        <div
          v-if="
            fields.rol.use && binds.width !== '' && fields.carton.use === false
          "
          :class="classes.container"
        >
          <div class="row">
            <p :class="classes.text" id="select-roll-wid">Rol breedte:</p>
            <p :class="classes.text">{{ binds.width }}{{ fields.rol.unit }}</p>
          </div>
        </div>
        <div
          v-if="
            fields.rol.use && binds.width === '' && fields.carton.use === false
          "
          :class="classes.container"
        >
          <div class="row">
            <p :class="classes.text" id="select-roll-wid">Rol breedte:</p>
            <p :class="classes.text">
              {{ fields.rol.options[0] }}{{ fields.rol.unit }}
            </p>
          </div>
        </div>
        <div
          v-if="fields.rol.use && fields.carton.use === false"
          :class="classes.container"
        >
          <div class="row">
            <p :class="classes.text + ' nr-roll'">Aantal rollen:</p>
            <p :class="classes.text">{{ binds.number }}</p>
          </div>
        </div>
        <!-- packaging -->
        <div v-if="fields.packaging.use" :class="classes.container">
          <div class="row">
            <p :class="classes.text + ' nr-package'">Aantal pakken:</p>
            <p :class="classes.text">{{ binds.number }}</p>
          </div>
        </div>
        <!-- carton -->
        <div v-if="fields.carton.use" :class="classes.container">
          <div class="row">
            <p :class="classes.text + ' nr'">Aantal:</p>
            <p :class="classes.text">{{ binds.number }}</p>
          </div>
        </div>
        <!-- end step 3 -->
      </div>
    </div>
    <!-- modal -->
    <div class="modal" id="errorModal">
      <div
        class="modalMsg d-flex flex-column justify-content-center align-items-center rounded"
      >
        <p v-if="alertMsg == 0" id="errorMsg1">
          Geef een aantal producten aan.
        </p>
        <p v-if="alertMsg == 1" id="errorMsg2">Geef een rol breedte aan.</p>
        <button id="ok" class="modalBtn" type="button" @mouseup="closeModal()">
          Oke
        </button>
      </div>
    </div>
    <div class="d-flex justify-content-between border-top text-center">
      <!-- button step back -->
      <div class="p-3 bd-highlight apartebtnStyle">
        <button
          type="button"
          @click="down()"
          v-show="step > 1 && !(step === 2 && product.kleurFilter === '')"
          class="btn btn-grey"
          id="back-1"
        >
          <i class="mt-1 me-1 fas fa-arrow-left"></i>Vorige
        </button>
      </div>

      <div class="p-3 bd-highlight">
        <!-- button new product -->
        <NavButton
          v-show="step === 3"
          :properties="newProductBtn"
          @mouseup="addToCart()"
        />

        <!-- back to products -->
        <NavButton v-show="step <= 2" :properties="HomeButton" />
      </div>
      <div class="p-3 bd-highlight">
        <!-- button step forward -->
        <button
          type="button"
          @click="up()"
          v-if="step < 3"
          class="btn btn-grey"
          id="back-2"
        >
          verder<i class="mt-1 ms-1 fas fa-arrow-right"></i>
        </button>
        <!-- button go to application -->
        <NavButton
          v-show="step === 3"
          :properties="ApplicationBtn"
          @mouseup="addToCart()"
        />
      </div>
    </div>
  </div>
</template>
<script>
import NavButton from "@/components/NavButton.vue";

export default {
  name: "OrderStepper",
  emits: ["stepper"],
  props: {
    product: Object,
  },
  components: {
    NavButton,
  },
  data() {
    return {
      alertMsg: 0,
      classes: {
        container: "d-inline bd-highlight",
        text: "text-start col-4 p-0 mb-2 mx-0",
        input: "form-control col-1 mb-1 mx-0 py-1",
        img: "colorPick",
        select: "form-select col-3 mb-1 mx-0 py-1",
        prodColor: "col-4 p-0 mb-2 mx-0",
        prodOptionHead: "text-uppercase mt-5 mb-4 mx-0",
      },
      ApplicationBtn: {
        routeName: this.$RouteNames.application,
        class: "btn btn-grey w-100 py-3",
        id: "app-quo",
        label: "Offerte aanvragen",
        type: "button",
        function: undefined,
      },
      HomeButton: {
        routeName: this.routeNameProducts,
        class: "btn btn-grey link-products w-100 py-3",
        id: "",
        label: "Terug naar producten",
        type: "btn",
        function: undefined,
      },
      newProductBtn: {
        routeName: this.$RouteNames.assortment,
        class: "btn btn-grey add-product apartebtnStyle2 w-100 py-3",
        id: "",
        label: "Nieuw product toevoegen",
        type: "button",
        function: "",
      },
      step: 1,
      fields: {},
      binds: {
        width: "",
        number: 0,
      },
      images: "",
      created: false,
      routeNameProducts: "",
    };
  },
  beforeCreate() {
    // get and build product route name
    const selection = this.$Functions.getSelection(this.$route.name);
    this.routeNameProducts = `${selection.assortmentCode}${selection.collectionCode}`;
  },
  created() {
    this.fields = this.buildFields(this.product);
    this.created = true;
    this.skipStep(this.product);
    this.images = this.$Functions.getImage(this.product.afbeelding);
  },
  beforeUpdate() {
    this.skipStep(this.product);
    if (this.created) {
      this.fields = this.buildFields(this.product);
    }
  },
  updated() {
    this.$store.commit("storeLocUpdate", true);
  },
  computed: {
    productLabel() {
      // build label
      let color = "";
      if (this.product.kleur !== undefined && this.product.kleur !== "") {
        if (this.product.kleur !== this.product.naam) {
          color = " " + this.product.kleur;
        }
      }
      return this.product.naam + color;
    },
  },
  methods: {
    skipStep(product) {
      if (this.step < 3 && product.kleurFilter === "") {
        this.step = 2;
        this.$emit("stepper", this.step);
      }
    },
    buildFields(product) {
      const fields = {
        rol: {
          use: false,
          options: [],
          value: 0,
          unit: "",
        },
        packaging: {
          use: false,
          value: 0,
        },
        width: {
          use: false,
          value: 0,
          unit: "",
        },
        length: {
          use: false,
          value: 0,
          unit: "",
        },
        carton: {
          use: false,
          value: 0,
        },
      };
      // rol
      if (
        product.rolBreedte[0] !== "" &&
        typeof product.rolBreedte === "object"
      ) {
        if (Array.isArray(product.rolBreedte)) {
          // use input
          fields.rol.use = true;
          // rol unit
          if (product.rolBreedteEenheid !== "") {
            fields.rol.unit = product.rolBreedteEenheid.toLowerCase();
          }
          // rol size
          if (product.lengte !== "") {
            fields.rol.value = product.lengte;
          }
          // rol options
          let iRolOptions = 0;
          for (const rolSize in product.rolBreedte) {
            if (
              !fields.rol.options.includes(product.rolBreedte[rolSize]) &&
              product.rolBreedte[rolSize] !== ""
            ) {
              fields.rol.options[iRolOptions] = product.rolBreedte[rolSize];
              iRolOptions++;
            }
            // end loop rol options
          }
        }
        // end rol
      }
      // packaging
      if (product.pak !== "" && product.pak !== undefined) {
        if (
          product.rolBreedte[0] === "" ||
          !Array.isArray(product.rolBreedte)
        ) {
          fields.packaging.use = true;
          fields.packaging.value = product.pak;
        }
      }
      // width
      if (product.breedte !== "" && Number(product.breedte) !== 0) {
        fields.width.use = true;
        fields.width.value = product.breedte;
        fields.width.unit = product.breedteEenheid;
      }
      // length
      if (
        product.lengte !== "" &&
        Number(product.lengte !== 0) &&
        !fields.rol.use
      ) {
        fields.length.use = true;
        fields.length.value = product.lengte;
        fields.length.unit = product.lengteEenheid;
      }
      // carton
      if (product.doos !== "" && product.doos !== undefined) {
        fields.carton.use = true;
        fields.carton.value = product.doos;
      }
      return fields;
      // end buildFields
    },
    up() {
      // count up from step 2 to 3
      if (this.step === 2) {
        if (this.binds.number > 0) {
          if (this.fields.rol.options.length > 1 && this.binds.width === "") {
            this.alertMsg = 1;
            document.querySelector("#errorModal").style.display = "block";
          } else {
            this.step++;
          }
        } else {
          this.alertMsg = 0;
          document.querySelector("#errorModal").style.display = "block";
        }
      }
      // count up from step 0 to 2
      if (this.step < 2) {
        this.step++;
      }
      if (this.step === 2) {
        this.images = this.$Functions.getImage(this.product.afbeelding);
      }
      this.$emit("stepper", this.step);
      // end up
    },
    down() {
      this.step--;
      this.$emit("stepper", this.step);
    },
    addToCart() {
      let product = this.product;
      product["amount"] = this.binds.number;
      if (this.binds.width !== "") {
        product["selectedRol"] = this.binds.width;
      }
      this.$store.commit("storeCART", product);
    },
    closeModal() {
      document.querySelector("#errorModal").style.display = "none";
    },
    // end methodes
  },
  watch: {},
};
</script>
<style scoped>
a {
  text-decoration: none;
  color: white;
}
.prodOption {
  height: 350px;
}
.form-control {
  width: 15% !important;
  border: 1px solid #ced4da !important;
}
.form-select {
  width: 15% !important;
  border: 1px solid #ced4da !important;
}
</style>
